'use strict';

module.exports = [
    'moment',
    function(moment) {

        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attributes, ngModelCtrl) {
                if(attributes.ngModel) {
                    ngModelCtrl.$formatters.push(value => {
                        const dateTime = moment.tz(value, window.CONFIG.timezone);
                        scope.datetime = dateTime;
                        return dateTime.format('HH:mm:ss');
                    });

                    ngModelCtrl.$parsers.push(value => {
                        return moment(scope.datetime.format('YYYY-MM-DD') + ' ' + value).format();
                    });
                }
            }
        }
    }];
